<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="desserts"
      sort-by="calories"
      class="elevation-1"
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-toolbar-title>Propuestas pendientes de emisión</v-toolbar-title>
          <v-divider
            class="mx-4"
            inset
            vertical
          ></v-divider>
          <v-spacer></v-spacer>
        </v-toolbar>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon
          small
          @click="emisionItem(item)"
        >
          mdi-send
        </v-icon>
      </template>
    </v-data-table>
    <!-- <template>
      <div class="vld-parent">
          <loading :active.sync="isLoading"
          :is-full-page="fullPage"></loading>
      </div>
    </template> -->
  </div>  
</template>

<script>
    import axios from "axios";
    import moment from "moment";
    //import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import {api_url} from '../config/index';

    export default {
    data: () => ({
      dialog: false,
      isLoading: false,
      headers: [
        {
          text: 'Fecha',
          align: 'start',
          sortable: false,
          value: 'fecha',
        },
        { text: 'Compañía', value: 'compania' },
        { text: 'Cliente', value: 'cliente' },
        { text: 'Propuesta', value: 'propuesta' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      desserts: [],
      editedIndex: -1,
      editedItem: {
        name: '',
        calories: 0,
        fat: 0,
        carbs: 0,
        protein: 0,
      },
      defaultItem: {
        name: '',
        calories: 0,
        fat: 0,
        carbs: 0,
        protein: 0,
      },
    }),
    created () {
      this.initialize()
    },

    methods: {
      async initialize () {
        this.isLoading = true;
          await axios.get(`${api_url}/emision/`, {
            headers: {
              'user_token': sessionStorage.getItem('token')
            }
          })
                  .then((response) => {      
                    this.desserts = [];           
                    let data = response.data;
                    data.forEach(element => {
                      //console.log(element);
                      let registro =  {
                                        id: element._id,
                                        fecha: moment(element.vigenciaDesde).format( 'DD-MM-YYYY') ,
                                        compania: element.compania,
                                        cliente: element.asegurado.documento+" - "+element.asegurado.nombre+" "+element.asegurado.apellido,
                                        propuesta: element.propuestaCompania,
                                        rut: element.asegurado.documento,
                                        patente: element.vehiculo.patente,
                                      };

                      this.desserts.push(registro);
                    });           
                  })
                  .catch((err) => {
                    console.log(err);
                  });          
          this.isLoading = false;
      },

      emisionItem (item) {
         this.$swal({
              title: 'Emisión en Compañía',
              text: `¿Estas seguro que deseas enviar propuesta ${item.propuesta} a emisión en compañía ${item.compania}?`,
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Sí, enviar!'
            }).then((result) => {
              console.log(result);
              if (result.value) {
                this.emitirCompania(item)
              }
            });
      },

      async emitirCompania( item ) {
        let data = {
          id: item.id,
          fechaInspeccion: '',
          numeroInspeccion: '',
        }
        this.isLoading = true;
        await axios.post(`${api_url}/emision/`, data)
          .then((resp) => {
            //console.log(resp);
            if (resp.status === 201){  
              this.$swal(
                  'Enviado!',
                  'Emision exitosa en compañía.',
                  'success'
                )

              this.loadData(); 
              this.alert = true;
              
            }
          })
          .catch((error ) => {
            console.log(error);
            this.$swal(
                  'Error!',
                  'Emision no existosa en compañía.',
                  'error'
                )

          });
        this.isLoading = false;
      }
      },

  }
</script>

<style scoped>
.swal-overlay {
   font-family: "Arial";
}
</style>